export const getters = {
  GET_SURVEY_ACCOUNT_ID: state => state.surveyAccountId,
  GET_SURVEY_TOKEN: state => state.surveyToken,
  GET_SURVEY_USER_ID: state => state.surveyUserId,
  GET_SURVEY_FAVORITE_UNIT_ID: state => state.surveyFavoriteUnitId,
  GET_SURVEY_SELECTED_UNIT: state => state.surveySelectedUnit,
  GET_SURVEY_PUBLIC_DETAILS: state => state.surveyPublicDetails
}
